<script setup lang="ts">
import { PhArrowUUpLeft } from '@phosphor-icons/vue';
import { useI18n } from 'vue-i18n';

defineProps<{
  disabled: boolean;
}>();

const { t } = useI18n();
</script>

<template>
  <button
    type="button"
    class="back-button"
    :aria-label="t('fileManager.fileExplorerView.fileExplorerHandler.backButton.goToParentFolderAriaLabel')"
    :disabled="disabled"
  >
    <PhArrowUUpLeft :size="16" />
  </button>
</template>

<style scoped>
.back-button {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: var(--handler-control-height);
  height: var(--handler-control-height);
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
}

.back-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
